import { http } from '../utils/http'

const searchAction = (params) => {
  const url = `/api/v1/email/user/list`
  return http.post(url, params)
};
const addAction = (params) => {
  const url = `/api/v1/email/user/add`
  return http.post(url, params)
};
const deleteAction = (params) => {
  const url = `/api/v1/email/user/delete`
  return http.post(url, params)
};
const enableAction = () => {
  const url = `/api/v1/email/enable`
  return http.post(url)
};
const disableAction = () => {
  const url = `/api/v1/email/disable`
  return http.post(url)
};
export default {
  searchAction,
  addAction,
  deleteAction,
  enableAction,
  disableAction,
}
